import { Flex, Typography } from "antd";
import { useSearchParams } from "react-router-dom";
import { InputSearch } from "@shared/ui";
import {
  DocstoreSections,
  getSelectedSectionFromParams,
} from "../../../../model";
import { useConfigurableTable } from "../docstore-section-table/hooks";
import { useDocstoreFilters } from "./hooks/use-docstore-filters";
import { useFilters, FilterType } from "./hooks/use-filters";
import { sectionFiltersConfig } from "./model/constants";
import { FilterDatePicker, FilterSelect } from "./ui";
import "./docstore-section-filters.scss";

interface DocstoreSectionFiltersProps {
  onFiltersChange?: (filters: FilterType[], searchValue: string) => void;
}

export function DocstoreSectionFilters({
  onFiltersChange,
}: DocstoreSectionFiltersProps) {
  const [searchParams] = useSearchParams();
  const selectedSection = getSelectedSectionFromParams(searchParams);
  const {
    filters: activeFilters,
    searchValue,
    addFilter,
    removeFilter,
    updateFilter,
    setSearchValue,
  } = useFilters();

  const { dataSource } = useConfigurableTable();
  const availableFilters =
    sectionFiltersConfig[
      DocstoreSections[selectedSection]
    ] || [];

  const {
    getOptionsForFilter,
    handleFilterChange,
    getFilterStyle,
    getFilterIcon,
    getFilterValue,
  } = useDocstoreFilters({
    activeFilters,
    dataSource,
    searchValue,
    addFilter,
    removeFilter,
    updateFilter,
    onFiltersChange,
  });

  const handleSearchChange = (value: string) => {
    setSearchValue(value);
    onFiltersChange?.(activeFilters, value);
  };

  return (
    <Flex
      gap="middle"
      vertical={
        DocstoreSections[selectedSection] === DocstoreSections.CERTIFICATE
      }
      justify="space-between"
    >
      <Flex justify="space-between" align="center">
        <InputSearch
          placeholder="Поиск"
          className="inputSearch"
          value={searchValue}
          onChange={(e) => handleSearchChange(e.target.value)}
          style={{ minWidth: "200px" }}
        />
      </Flex>

      <Flex gap="small" align="center" wrap="wrap">
        {availableFilters.length > 0 && (
          <Typography.Text style={{ marginRight: 8 }}>Фильтры:</Typography.Text>
        )}

        {availableFilters.map((filterLabel) => {
          const filterValue = getFilterValue(filterLabel);
          const isFilterActive =
            filterValue && filterValue !== null && filterValue !== "";
          return (
            <Flex
              key={filterLabel}
              align="center"
              gap="small"
              style={
                isFilterActive
                  ? {
                      backgroundColor: "#EAEEF8",
                      padding: "4px",
                      paddingLeft: "12px",
                      borderRadius: "10px",
                      gap: "8px",
                    }
                  : {}
              }
            >
              {isFilterActive && (
                <Typography.Text
                  style={{
                    fontSize: "12px",
                    whiteSpace: "nowrap",
                  }}
                >
                  {filterLabel}
                </Typography.Text>
              )}
              <div>
                {filterLabel === "Дата выдачи" ||
                filterLabel === "Срок действия" ? (
                  <FilterDatePicker
                    filterLabel={filterLabel}
                    getFilterValue={getFilterValue}
                    getFilterStyle={getFilterStyle}
                    handleFilterChange={handleFilterChange}
                    getFilterIcon={getFilterIcon}
                  />
                ) : (
                  <FilterSelect
                    filterLabel={filterLabel}
                    getFilterStyle={getFilterStyle}
                    getFilterIcon={getFilterIcon}
                    getOptionsForFilter={getOptionsForFilter}
                    getFilterValue={(label) => {
                      const value = getFilterValue(label);
                      return value ? String(value) : null;
                    }}
                    handleFilterChange={handleFilterChange}
                    isFilterActive={Boolean(isFilterActive)}
                  />
                )}
              </div>
            </Flex>
          );
        })}
      </Flex>
    </Flex>
  );
}
